<!-- ARIA Completed -->
<div class="input-group">
  <label for="locale-select" class="visually-hidden" i18n>Dil / Bölge</label>
  <select id="locale-select" class="form-select text-center" [(ngModel)]="localeId" style="text-align-last: center;">
    @for (locale of locales; track locale) {
    <option [value]="locale.id">{{ locale.label }}</option>
    }
  </select>

  <label for="currency-select" class="visually-hidden" i18n>Para Birimi</label>
  <select id="currency-select" class="form-select text-center" [(ngModel)]="currency" style="text-align-last: center;">
    @for (currency of currencies; track currency) {
    <option [value]="currency">{{ currency }}</option>
    }
  </select>
</div>